import React, { useState } from "react";
import { Button, ShowProps } from "react-admin";
import { Grid, makeStyles, Tab, Tabs, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import { useHistory } from "react-router-dom";
import IconPlus from "@material-ui/icons/Add";
import TabPanel from "../routeplans/components/TabPanel";
import SubcontractorAdhocFeeTable from "../subcontractorAdhocFees/components/SubcontractorAdhocFeeTable";
import SubcontractorPurchaseInvoiceSummaryTable from "../subcontractorPurchaseInvoiceSummaries/components/SubcontractorPurchaseInvoiceSummaryTable";
import SubcontractorPurchaseInvoiceTable from "../subcontractorPurchaseInvoices/components/SubcontractorPurchaseInvoiceTable";
import SubcontractorErpTable from "../subcontractorErps/components/SubcontractorErpTable";
import SubcontractorAdjustmentPriceTable from "../subcontractorAdjustmentPrices/components/SubcontractorAdjustmentPriceTable";

const useStyles = makeStyles({
  sidePanelTabs: {
    borderBottom: "1px solid #C4C4C4",
    "& .MuiTabs-fixed > .MuiTabs-indicator": {
      backgroundColor: "#989898 !important",
      height: "3px !important",
    },
  },
});

const Financial = (props: ShowProps) => {
  const [valueAdhocFeeListTab, setValueAdhocFeeListTab] = useState(0);
  const [valuePurchaseInvoiceListTab, setValuePurchaseInvoiceListTab] =
    useState(0);
  const [valueErpListTab, setValueErpListTab] = useState(0);
  const [valueAdjustmentPriceListTab, setValueAdjustmentPriceListTab] =
    useState(0);

  const classes = useStyles();

  const { id } = props;

  const handleChangeAdhocFeeListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ) => {
    setValueAdhocFeeListTab(newValue);
  };
  const adhocFeeListProps = (index: number) => {
    return {
      id: `adhocFeeList-tab-${index}`,
      "aria-controls": `adhocFeeList-tabpanel-${index}`,
    };
  };

  const handleChangePurchaseInvoiceListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ) => {
    setValuePurchaseInvoiceListTab(newValue);
  };
  const purchaseInvoiceListProps = (index: number) => {
    return {
      id: `purchaseInvoiceList-tab-${index}`,
      "aria-controls": `purchaseInvoiceList-tabpanel-${index}`,
    };
  };

  const handleChangeErpListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ) => {
    setValueErpListTab(newValue);
  };
  const erpListProps = (index: number) => {
    return {
      id: `erpList-tab-${index}`,
      "aria-controls": `erpList-tabpanel-${index}`,
    };
  };

  const handleChangeAdjustmentPriceListTab = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ) => {
    setValueAdjustmentPriceListTab(newValue);
  };
  const adjustmentPriceListProps = (index: number) => {
    return {
      id: `adjustmentPriceList-tab-${index}`,
      "aria-controls": `adjustmentPriceList-tabpanel-${index}`,
    };
  };

  const InvoiceCreateButton = () => {
    const history = useHistory();
    return (
      <Button
        label="Adhoc Fee"
        onClick={() =>
          history.push(
            `/subcontractorAdhocFees/create?source=${JSON.stringify({
              subcontractorId: Number(id),
            })}&subcontractorId=${id}`,
          )
        }
      >
        <IconPlus />
      </Button>
    );
  };

  const AdjustmentPriceCreateButton = () => {
    const history = useHistory();
    return (
      <Button
        label="Adjustment Price"
        onClick={() =>
          history.push(
            `/subcontractorAdjustmentPrices/create?source=${JSON.stringify({
              subcontractorId: Number(id),
            })}&subcontractorId=${id}`,
          )
        }
      >
        <IconPlus />
      </Button>
    );
  };

  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Financial Information</Typography>
        </Grid>

        <Grid item xs={8}>
          <InvoiceCreateButton />
          <AdjustmentPriceCreateButton />
        </Grid>
        <Grid item xs={4} />

        {/* Adhoc fee table */}
        <Grid item xs={12}>
          <Tabs
            value={valueAdhocFeeListTab}
            onChange={handleChangeAdhocFeeListTab}
            aria-label="Adhoc Fee List"
            className={classes.sidePanelTabs}
          >
            <Tab label="Unapproved Adhoc Fees" {...adhocFeeListProps(0)} />
            <Tab label="Approved Adhoc Fees" {...adhocFeeListProps(1)} />
            <Tab label="Rejected Adhoc Fees" {...adhocFeeListProps(2)} />
            <Tab label="Issued Adhoc Fees" {...adhocFeeListProps(3)} />
          </Tabs>

          <TabPanel value={valueAdhocFeeListTab} index={0}>
            <Grid item xs={12}>
              <SubcontractorAdhocFeeTable
                subcontractorId={Number(id)}
                hasIssued={false}
                status="Pending"
                isFixedHeight
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valueAdhocFeeListTab} index={1}>
            <Grid item xs={12}>
              <SubcontractorAdhocFeeTable
                subcontractorId={Number(id)}
                hasIssued={false}
                status="Approved"
                isFixedHeight
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valueAdhocFeeListTab} index={2}>
            <Grid item xs={12}>
              <SubcontractorAdhocFeeTable
                subcontractorId={Number(id)}
                hasIssued={false}
                status="Rejected"
                isFixedHeight
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valueAdhocFeeListTab} index={3}>
            <Grid item xs={12}>
              <SubcontractorAdhocFeeTable
                subcontractorId={Number(id)}
                hasIssued={true}
                status="Approved"
                isFixedHeight
              />
            </Grid>
          </TabPanel>
        </Grid>

        {/* Erp table */}
        <Grid item xs={12}>
          <Tabs
            value={valueErpListTab}
            onChange={handleChangeErpListTab}
            aria-label="Subcontractor ERP List"
            className={classes.sidePanelTabs}
          >
            <Tab label="Unissued ERP Charges" {...erpListProps(0)} />
            <Tab label="Issued ERP Charges" {...erpListProps(1)} />
          </Tabs>

          <TabPanel value={valueErpListTab} index={0}>
            <Grid item xs={12}>
              <SubcontractorErpTable
                subcontractorId={Number(id)}
                hasIssued={false}
                isFilterByPeriod
                isFixedHeight
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valueErpListTab} index={1}>
            <Grid item xs={12}>
              <SubcontractorErpTable
                subcontractorId={Number(id)}
                hasIssued={true}
                isFilterByPeriod
                isFixedHeight
              />
            </Grid>
          </TabPanel>
        </Grid>

        {/* Adjustment price table */}
        <Grid item xs={12}>
          <Tabs
            value={valueAdjustmentPriceListTab}
            onChange={handleChangeAdjustmentPriceListTab}
            aria-label="Subcontractor Adjustment Price List"
            className={classes.sidePanelTabs}
          >
            <Tab
              label="Approved Adjustment Prices"
              {...adjustmentPriceListProps(0)}
            />
            <Tab
              label="Unapproved Adjustment Prices"
              {...adjustmentPriceListProps(1)}
            />
            <Tab
              label="Rejected Adjustment Prices"
              {...adjustmentPriceListProps(2)}
            />
          </Tabs>

          <TabPanel value={valueAdjustmentPriceListTab} index={0}>
            <Grid item xs={12}>
              <SubcontractorAdjustmentPriceTable
                subcontractorId={Number(id)}
                status="Approved"
                isFixedHeight
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valueAdjustmentPriceListTab} index={1}>
            <Grid item xs={12}>
              <SubcontractorAdjustmentPriceTable
                subcontractorId={Number(id)}
                status="Draft"
                isFixedHeight
              />
            </Grid>
          </TabPanel>

          <TabPanel value={valueAdjustmentPriceListTab} index={2}>
            <Grid item xs={12}>
              <SubcontractorAdjustmentPriceTable
                subcontractorId={Number(id)}
                status="Rejected"
                isFixedHeight
              />
            </Grid>
          </TabPanel>
        </Grid>

        {/* Purchase invoice table */}
        <Grid item xs={12}>
          <Tabs
            value={valuePurchaseInvoiceListTab}
            onChange={handleChangePurchaseInvoiceListTab}
            aria-label="Purchase Invoice List"
            className={classes.sidePanelTabs}
          >
            <Tab label="Route Transactions" {...purchaseInvoiceListProps(0)} />
            <Tab
              label="Approved Purchase Invoices"
              {...purchaseInvoiceListProps(1)}
            />
          </Tabs>

          <TabPanel value={valuePurchaseInvoiceListTab} index={0}>
            <Grid item xs={12}>
              <SubcontractorPurchaseInvoiceSummaryTable
                subcontractorId={Number(id)}
                referenceResource="subcontractorRouteTransactions"
                isFixedHeight
              />
            </Grid>
          </TabPanel>
          <TabPanel value={valuePurchaseInvoiceListTab} index={1}>
            <Grid item xs={12}>
              <SubcontractorPurchaseInvoiceTable
                subcontractorId={Number(id)}
                statusIn={["Approved", "Unposted", "Posted", "Rejected"]}
                isFixedHeight
              />
            </Grid>
          </TabPanel>
        </Grid>
      </SanitizedGrid>
    </>
  );
};

export default Financial;
